export enum WalletoServices {
  Plastic = 'IssueW',
  Virtual = 'IssueWV'
}

export enum IntercashServices {

  Euro_USD_250 = 'Issue250USD',
  Euro_USD_20k = 'Issue250USD'
}
